import useOnScreen from "../../components/UseOnScreen/UseOnScreen";
import TypingEffect from "../../components/Animation/TypingEffect";
import "../Services/StudyGroup.css";

const StudyGroup = () => {
  const [aboutRef,
    isVisible] = useOnScreen({threshold: 0.5, once: true});
  const groupText = "O estudo é, antes de tudo, um laço. Junte-se à nossa interlocução.";

  return (
    <div id="study-group" className="" ref={aboutRef}>
      <div className="group-container">
        <div className="group-text">
          <h1>Grupos de Estudos</h1>
          <span>
            Coordeno grupos de estudos, orientada pela psicanálise, que articulam leitura e discussão, pensando temas relacionados a clínica e a teoria psicanalítica em interlocução com outros campos do saber.
            <br></br>
            Os encontros são realizados em plataforma online e  ao vivo.
          </span>
        </div>
        <div className="group-second-text">
            {isVisible ? (
                <>
                    <TypingEffect
                        text={groupText}
                        speed={70}    
                        className="group-phrase"
                    />
                </>
            ) : (
                <div className="placeholder-text">
                    <span className="group-phrase">{groupText}</span>
                </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default StudyGroup;
